import './codeInput.scss'
import { useStore } from '@/store'
import {
  FormEventHandler,
  useCallback,
  useEffect,
  useRef,
  useState,
  useMemo,
} from 'react'
import { useLocal } from '@/i18n/LocalContext'

interface CodeInputProps {
  readOnly?: boolean
  value?: string
  /** 是否要输入自己的UID */
  self?: boolean
  placeholder?: string
  onChange?: (val: string) => void
}
export default function CodeInput(props: CodeInputProps) {
  const inputElem = useRef<HTMLInputElement | null>(null)
  const { $t } = useLocal()
  const { dispatch } = useStore()
  // const [current, setCurrent] = useState(props.value || '')
  /* const oldValue = useRef(current)
  const recordSelectionStart = useRef<number | null>(current.length + 1) */

  const setCode = useCallback(
    (val: string) => {
      // setCurrent(val)
      props.onChange instanceof Function && props.onChange(val)

      if (props.self) {
        dispatch({
          type: 'setCode',
          data: {
            code: val,
          },
        })
      }
    },
    [props]
  )

  const handleClear = useCallback(() => {
    // if (!current) return

    setCode('')
  }, [setCode /* , current */])

  /* useEffect(() => {
    const input = inputElem.current
    const selectionStart = recordSelectionStart.current

    if (oldValue.current === current) {
      _handle()
      return
    }

    oldValue.current = current
    _handle()

    function _handle() {
      if (!input || typeof selectionStart !== 'number') return

      input.setSelectionRange(selectionStart, selectionStart)
    }
  }, [current]) */

  const handle = useCallback<FormEventHandler<HTMLInputElement>>(
    (e) => {
      if (inputElem.current == null) return

      const target = e.target as HTMLInputElement

      const newValue = format(target.value)

      /* if (newValue === current) {
        setTimeout(() => {
          inputElem.current?.setSelectionRange(
            recordSelectionStart.current,
            recordSelectionStart.current
          )
        }, 1)
        return
      } */

      // recordSelectionStart.current = getSelectionStart()
      setCode(newValue)

      function format(val: unknown) {
        if (typeof val === 'string') {
          let str = val.replace(/[^a-z0-9]/gi, '').toUpperCase()
          return str.slice(0, 9)
        }
        return ''
      }

      function getSelectionStart() {
        const input = inputElem.current
        const selectionStart: number | null = input
          ? input.selectionStart
          : null
        return selectionStart
      }
    },
    [
      /* current */
    ]
  )

  const clearIconStyle = useMemo<React.CSSProperties>(
    () => ({
      display: props.value ? '' : 'none',
    }),
    [props]
  )

  return (
    <div className="code-input-block">
      <input
        ref={inputElem}
        className="code-input"
        type="text"
        placeholder={props.placeholder || $t('请输入UID')}
        readOnly={props.readOnly}
        value={props.value}
        onInput={handle}
      />
      <a className="code-input-clear" onClick={handleClear}>
        <i style={clearIconStyle}></i>
      </a>
    </div>
  )
}
